/** 与 easy-editor 一致：[微笑]；兼容 Expo 旧协议 [weixiao] */
import chongbai from './stickers/chongbai.png';
import kushuai from './stickers/kushuai.png';
import kuxiao from './stickers/kuxiao.png';
import renzhen from './stickers/renzhen.png';
import shuijiao from './stickers/shuijiao.png';
import weixiao from './stickers/weixiao.png';
import xihuan from './stickers/xihuan.png';
import yihuo from './stickers/yihuo.png';
import zunjing from './stickers/zunjing.png';

export interface EmojiStickerItem {
  id: string;
  src: string;
}

const STICKER_SRC_BY_FILE: Record<string, string> = {
  'chongbai.png': chongbai,
  'kushuai.png': kushuai,
  'kuxiao.png': kuxiao,
  'renzhen.png': renzhen,
  'shuijiao.png': shuijiao,
  'weixiao.png': weixiao,
  'xihuan.png': xihuan,
  'yihuo.png': yihuo,
  'zunjing.png': zunjing,
};

/** 文件名（无扩展）→ 展示用协议 id */
const EXPO_FILE_TO_PROTOCOL_ID: Record<string, string> = {
  weixiao: '微笑',
  xihuan: '喜欢',
  zunjing: '尊敬',
  yihuo: '疑惑',
  shuijiao: '睡觉',
  renzhen: '认真',
  kushuai: '酷帅',
  kuxiao: '哭笑',
  chongbai: '崇拜',
};

export const EMOJI_STICKERS: EmojiStickerItem[] = Object.entries(
  EXPO_FILE_TO_PROTOCOL_ID,
).map(([fileStem, id]) => ({
  id,
  src: STICKER_SRC_BY_FILE[`${fileStem}.png`],
}));

const TOKEN_TO_SRC = new Map<string, string>();

function registerToken(token: string, fileName: string) {
  const src = STICKER_SRC_BY_FILE[fileName];
  if (src) {
    TOKEN_TO_SRC.set(token, src);
  }
}

Object.entries(EXPO_FILE_TO_PROTOCOL_ID).forEach(([fileStem, protocolId]) => {
  const fileName = `${fileStem}.png`;
  registerToken(protocolId, fileName);
  registerToken(fileStem, fileName);
});

export function getEmojiStickerSrc(token: string): string | undefined {
  return TOKEN_TO_SRC.get(token);
}

export function isKnownEmojiStickerToken(token: string): boolean {
  return TOKEN_TO_SRC.has(token);
}
